import { render, staticRenderFns } from "./ServiceSliderSection.vue?vue&type=template&id=020f1c60"
import script from "./ServiceSliderSection.vue?vue&type=script&lang=js"
export * from "./ServiceSliderSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceSliderSection.vue?vue&type=style&index=0&id=020f1c60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports